import '../components/header-bar/header-bar';
import '../components/form/button-stateful';
import '../components/form/input-statefull';
import '../components/linkedin-auth';

import { requestHandler } from './tools';

(function() {
    const loginbtn = document.querySelector('#auth-action-signin-btn') as any;

    const login = () => {
        const loginForm = document.querySelector('#login-auth-form') as HTMLFormElement;
        const emailInput = loginForm.querySelector('[type=email]') as HTMLInputElement;
        const passwordInput = loginForm.querySelector('[type=password]') as HTMLInputElement;
        const email = emailInput.value;
        const password = passwordInput.value;

        loginbtn.setAttribute('state', 'loading');
        requestHandler({ url: '/v2/auth/login', method: 'POST', payload: JSON.stringify({ email, password }) })
            .then(data => {
                const response = JSON.parse(data?.data);
                window.location.href = response?.redirectUrl;
                loginbtn.setAttribute('state', '');
            }).catch(e => {
                loginbtn.setAttribute('state', '');
                console.log('error', e);
            });

    };
    loginbtn.addEventListener('click', login);

})();
